import { Injectable } from '@angular/core';
import { Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthTokenService } from '../_services/auth-token.service';

@Injectable({
  providedIn: 'root'
})
export class HomeGuard  {

  constructor(
    private authTokenService: AuthTokenService,
    private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.handle();
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.handle();
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return this.handle();
  }

  handle(): boolean {
    if (!this.authTokenService.getAuthTokens()) {
      if (location.pathname.startsWith('/auth/')) {
        this.router.navigate([`/auth/login`]);
      }
      else {
        this.router.navigate([`/auth/login`], { queryParams: { redirecturl: location.pathname } });
      }
      return false;
    }

    return true;
  }
}
